import React from 'react';
import Copyrights from '../Copyrights';
import Footer from '../Footer';
import SEO from '../SEO';

export default function TermsConditions() {
    return (
        <>
            <SEO
                title='Terms & Conditions'
                description="Read the terms and conditions governing your use of IURIX's website and services."
                path='/terms-conditions'
            />
            <main className='container'>
                <h1>Terms and Conditions</h1>

                <p>Welcome to IURIX!</p>
                
                <p>These terms and conditions outline the rules and regulations for the use of IURIX's Website.</p>
                
                <p>By accessing this website we assume you accept these terms and conditions. Do not continue to use IURIX if you do not agree to take all of the terms and conditions stated on this page.</p>
                
                <h2><strong>License</strong></h2>
                
                <p>Unless otherwise stated, IURIX and/or its licensors own the intellectual property rights for all material on IURIX. All intellectual property rights are reserved.</p>
                
                <p>You must not:</p>
                <ul>
                    <li>Republish material from IURIX</li>
                    <li>Sell, rent or sub-license material from IURIX</li>
                    <li>Reproduce, duplicate or copy material from IURIX</li>
                    <li>Redistribute content from IURIX</li>
                </ul>
                
                <h2><strong>Disclaimer</strong></h2>
                
                <p>To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website.</p>
                
                <p>As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.</p>
            </main>
            <Copyrights />
            <Footer />
        </>
    );
}
